import { LazyModule } from './lazy-module';

export function Reality() {
  return <LazyModule moduleCode="reality" />;
}
